module.exports = __webpack_public_path__ + "media/theme/wall__sidebar--psn-e2003fff.svg";